import React from 'react';
import { Divider, Tabs, message } from 'antd'
import InputType from './input-const';
import SettingInput from "./setting-input";
import SettingTextArea from "./setting-textarea";
import SettingRadio from './setting-radio';
import SettingSelect from './setting-select';
import SettingSwitch from './setting-switch';

const TabPane = Tabs.TabPane;

/**
 * 输入控件参数设置页面
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-02-05 14:56:33
 * Version: 1.0
 * Modify log:
 */
class EditPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            defaultActiveKey: InputType.INPUT, //初始显示输入控件配置页面
            feature: '' //输入控件配置参数
        }
    }

    static defaultProps = {
        initFeature: ''  //初始输入控件配置参数
    };

    //在渲染前调用,可在此最后一次初始化组件状态
    componentWillMount() {
        //将输入控件配置参数设置到状态中
        if (this.props.initFeature) {
            try {
                let initFeature = JSON.parse(this.props.initFeature);
                this.setState({
                    defaultActiveKey: initFeature.type ? initFeature.type : InputType.INPUT,
                    feature: this.props.initFeature
                });
            } catch (e) {
                console.log(e);
                message.error('解析控件配置参数出错！');
            }
        }
    }

    //React将会在组件实例化的时候调用ref回调和DOM元素，当它销毁的时候调用它和null。
    saveSettingInputRef = (ref) => {
        this.settingInputRef = ref;
        //这里判断是否是初始进来的页面，如果是初始页面，则防止feature被覆盖
        if (ref !== null && (this.state.defaultActiveKey != InputType.INPUT || this.state.feature == '')) {
            //当组件实例化时（这里是当前显示的组件），同步获取其feature
            this.setState({ feature: ref.getFeature() });
        }
    }

    saveSettingTextAreaRef = (ref) => {
        this.settingTextAreaRef = ref;
        if (ref !== null && (this.state.defaultActiveKey != InputType.TEXTAREA || this.state.feature == '')) {
            this.setState({ feature: ref.getFeature() });
        }
    }

    saveSettingRadioRef = (ref) => {
        this.settingRadioRef = ref;
        if (ref !== null && (this.state.defaultActiveKey != InputType.RADIO || this.state.feature == '')) {
            this.setState({ feature: ref.getFeature() });
        }
    }

    saveSettingSelectRef = (ref) => {
        this.settingSelectRef = ref;
        if (ref !== null && (this.state.defaultActiveKey != InputType.SELECT || this.state.feature == '')) {
            this.setState({ feature: ref.getFeature() });
        }
    }

    saveSettingSwitchRef = (ref) => {
        this.settingSwitchRef = ref;
        if (ref !== null && (this.state.defaultActiveKey != InputType.SWITCH || this.state.feature == '')) {
            this.setState({ feature: ref.getFeature() });
        }
    }

    //切换面板的回调
    handleTabsChange = (key) => {

        //切换面板时，手动获取对应输入控件的配置参数
        if (key == InputType.INPUT) {
            /** 如果该页面未显示过(实例化)，则这里的ref会为undefined，所以会调用ref的回调方法，在那里获取feature。
                当实例化过一次了，下次就可以调用此方法*/
            if (this.settingInputRef !== undefined) {
                this.setState({ feature: this.settingInputRef.getFeature() });
            }
        } else if (key == InputType.TEXTAREA) {
            if (this.settingTextAreaRef !== undefined) {
                this.setState({ feature: this.settingTextAreaRef.getFeature() });
            }
        } else if (key == InputType.RADIO) {
            if (this.settingRadioRef !== undefined) {
                this.setState({ feature: this.settingRadioRef.getFeature() });
            }
        } else if (key == InputType.SELECT) {
            if (this.settingSelectRef !== undefined) {
                this.setState({ feature: this.settingSelectRef.getFeature() });
            }
        } else if (key == InputType.SWITCH) {
            if (this.settingSwitchRef !== undefined) {
                this.setState({ feature: this.settingSwitchRef.getFeature() });
            }
        }
    }

    //子组件状态提升，同步当前设置的参数
    handleInputChange = (feature) => {
        this.setState({
            feature: feature
        });
    }

    //供父组件获取feature
    getFeature = () => {
        return this.state.feature;
    }

    render() {

        let initFeature = {};
        if (this.state.feature !== undefined && this.state.feature != '') {
            try {
                initFeature = JSON.parse(this.state.feature);
            } catch (e) {
                console.log(e);
                message.error('解析控件配置参数出错！');
            }
        }

        return (
            <div id="div-inputPicker-editPage">
                <Tabs
                    defaultActiveKey={this.state.defaultActiveKey}
                    tabPosition="left"
                    size="small"
                    onChange={this.handleTabsChange}
                >
                    <TabPane tab="单行输入框" key={InputType.INPUT}>
                        <SettingInput ref={this.saveSettingInputRef}
                            initFeature={initFeature.type == InputType.INPUT ? this.state.feature : null}
                            onChange={this.handleInputChange}
                        />
                    </TabPane>
                    <TabPane tab="多行输入框" key={InputType.TEXTAREA}>
                        <SettingTextArea ref={this.saveSettingTextAreaRef}
                            initFeature={initFeature.type == InputType.TEXTAREA ? this.state.feature : null}
                            onChange={this.handleInputChange}
                        />
                    </TabPane>
                    <TabPane tab="下拉选择器" key={InputType.SELECT}>
                        <SettingSelect ref={this.saveSettingSelectRef}
                            initFeature={initFeature.type == InputType.SELECT ? this.state.feature : null}
                            onChange={this.handleInputChange}
                        />
                    </TabPane>
                    <TabPane tab="开关选择器" key={InputType.SWITCH}>
                        <SettingSwitch ref={this.saveSettingSwitchRef}
                            initFeature={initFeature.type == InputType.SWITCH ? this.state.feature : null}
                            onChange={this.handleInputChange}
                        />
                    </TabPane>
                    <TabPane tab="单选框" key={InputType.RADIO}>
                        <SettingRadio ref={this.saveSettingRadioRef}
                            initFeature={initFeature.type == InputType.RADIO ? this.state.feature : null}
                            onChange={this.handleInputChange}
                        />
                    </TabPane>
                </Tabs>
            </div>
        )
    }

}

export default EditPage;


// WEBPACK FOOTER //
// ./components/common/NHInputPicker/edit-page.js